import { Container, Row, Col } from "react-bootstrap";
import Gallery from "../../components/Gallery/Gallery";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { Helmet } from "react-helmet-async";

const PhotoGallery = () => {
  return (
    <>
      <Helmet>
        <title>Travel Inspiration Gallery – Shivay Tour & Travels</title>
        <meta
          name="description"
          content="Get inspired for your next trip! Browse our travel gallery featuring stunning destinations, tour experiences, and vehicles from Shivay Tour & Travels."
        />
        <meta name="keywords" content="travel inspiration gallery, travel photos, Gujarat tours" />
        <link rel="canonical" href="https://www.shivaytourandtravells.com/gallery" />
      </Helmet>

      <Breadcrumbs title="Gallery" pagename="Gallery" />
      <section className="py-5" style={{ overflow: "hidden" }}>
        <Container>
          <Row>
            <Col>
              <Gallery />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PhotoGallery;
